import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { Co2DashboardOverview, Co2Recommendations } from "@components/main/co2";
import { Box, Grid } from "@components/base";

const CsrdDashboardPage: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const element = document.getElementById(location.state.scrollTo);

      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "start",
        });
      }
    }
  }, [location]);

  return (
    <Box mb={6}>
      <Grid container spacing={3}>
        <Grid size={12}>
          <Co2DashboardOverview version="esrs" />
        </Grid>
        <Grid id={"recommendation"} size={12}>
          <Co2Recommendations />
        </Grid>
      </Grid>
    </Box>
  );
};

export default CsrdDashboardPage;
